import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "./../../../../languages/index";
import DashBoardNewOrdetabs from "./newordertabs";
import DashboardProductBaseTabs from "./productbasetabs";
import ProductBaseToday from "./productbastable/productdayindex";
import NewOrderToday from "./newordertable/neworderdayindex";

class ProductNewoder extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    // All Binded Functions
  }
  customerdetails = (e, data) => {
    //  console.log("this.props.data", this.props.data)
    this.setState({ showUploadSection: !this.state.showUploadSection });
    //   this.props.data();
  };

  render() {
    return (
      <div class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 ">
        <div class="box-border h-128 w-full bg-custWhite mb-5">
          <ProductBaseToday />
          {/* <div class=" grid grid-cols-1 grid-flow-col gap-4 pl-3 mt-1">
              <div className="text-ternary  group flex items-center px-3 py-2 text-sm font-medium rounded-md"> {LocaleStrings.productbase}</div>
            </div>
            <div class="">
            <div className="">
              <DashboardProductBaseTabs showUploadSection={this.customerdetails}  />
              </div>
              </div> */}
        </div>
        <div class="box-border h-128 w-full bg-custWhite mb-5">
          <NewOrderToday />
          {/* <div class=" grid grid-cols-1 grid-flow-col gap-4 pl-3 mt-1">
              <div className="text-ternary  group flex items-center px-3 py-2 text-sm font-medium rounded-md"> {LocaleStrings.newoders}</div>
            </div>
            <div class="">
            <div className="">
              <DashBoardNewOrdetabs showUploadSection={this.customerdetails}  />
              </div>
              </div> */}
        </div>
      </div>
    );
  }
}

var mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  user: state.user,
  session: state.session,
});

export default connect(mapStateToProps, {})(ProductNewoder);
